import { render, staticRenderFns } from "./CampaignName.vue?vue&type=template&id=11b96c63&scoped=true&"
import script from "./CampaignName.vue?vue&type=script&lang=js&"
export * from "./CampaignName.vue?vue&type=script&lang=js&"
import style0 from "./CampaignName.vue?vue&type=style&index=0&id=11b96c63&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b96c63",
  null
  
)

export default component.exports